module.exports = __webpack_public_path__ + "img/tiq_logo.233fe876.png";